// util/date.js
import { isValid } from "date-fns";

/**
 * Parses either:
 * - Date object
 * - ISO date-only string: "YYYY-MM-DD" (treat as local midnight to avoid 1-day shift)
 * - ISO datetime string: "YYYY-MM-DDTHH:mm:ss..." (normal parsing)
 */
export function parseDateForUI(value) {
    if (!value) return null;

    if (value instanceof Date) return isValid(value) ? value : null;

    if (typeof value === "string") {
        // If backend sends date-only (no timezone), DO NOT do new Date("YYYY-MM-DD")
        // because it is interpreted as UTC and can shift a day in local time.
        const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
        const d = isDateOnly ? new Date(`${value}T00:00:00`) : new Date(value);
        return isValid(d) ? d : null;
    }

    const d = new Date(value);
    return isValid(d) ? d : null;
}